import { render } from "./CosmoBuildApp.vue?vue&type=template&id=abb7decc&scoped=true"
import script from "./CosmoBuildApp.vue?vue&type=script&lang=js"
export * from "./CosmoBuildApp.vue?vue&type=script&lang=js"

import "./CosmoBuildApp.vue?vue&type=style&index=0&id=abb7decc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abb7decc"]])

export default __exports__